import {
  useReadFiscalNoteEntities,
  useSendFiscalNoteEmail,
} from '@/api/accounting-dealer'
import { toast } from '@/helpers'
import { LoadingButton } from '@mui/lab'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  MenuItem,
  DialogActions,
  DialogProps,
  Button,
  Stack,
} from '@mui/material'
import { ChangeEvent, useState } from 'react'

type SendEmailDialogProps = DialogProps & {
  onClose: () => void
  fiscalNoteKey: string
}

export function SendEmailDialog({
  fiscalNoteKey,
  ...props
}: SendEmailDialogProps) {
  const [toAddress, setToAddress] = useState<string[]>([])
  const [ccAddresses, setCcAddresses] = useState('')

  const { data: entities = [] } = useReadFiscalNoteEntities(fiscalNoteKey, {
    enabled: props.open,
  })

  const { mutate: sendEmail, isPending: sendingEmail } = useSendFiscalNoteEmail(
    {
      onSuccess: () => {
        toast.success('E-mail enviado com sucesso')
        props.onClose()
      },
    },
  )

  const handleChangeToAddress = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { value } = event.target
    const newValue = typeof value === 'string' ? value.split(',') : value
    setToAddress(newValue)
  }

  const handleSendEmail = () => {
    sendEmail({
      fiscal_note_key: fiscalNoteKey,
      to_address: toAddress,
      cc_addresses: ccAddresses ? ccAddresses.split(',') : [],
    })
  }

  return (
    <Dialog {...props}>
      <DialogTitle>Enviar por e-mail</DialogTitle>

      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField
            select
            name="toAddress"
            label="Para"
            value={toAddress}
            onChange={handleChangeToAddress}
            slotProps={{
              select: {
                multiple: true,
              },
            }}
          >
            {entities.map(({ email }) => (
              <MenuItem key={email} value={email}>
                {email}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            name="ccAddresses"
            label="CC"
            placeholder="Insira os e-mails separados por vírgula. Ex: email1,email2"
            value={ccAddresses}
            onChange={(event) => setCcAddresses(event.target.value)}
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button variant="text" onClick={props.onClose}>
          Cancelar
        </Button>
        <LoadingButton
          disabled={!toAddress.length}
          loading={sendingEmail}
          onClick={handleSendEmail}
        >
          Enviar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
